import { useEffect, useState } from 'react'
import { authMode } from '../lib/auth'
import { canPromptInstall, isStandalone, onInstallChange, promptInstall } from '../lib/install'
import { afterInstallAskPush } from '../lib/push'
import { haptic } from '../lib/telegram'
import { useSirr } from '../store'

/**
 * Кнопка установки в шапке.
 *
 * Баннер под шапкой человек закрывает один раз и больше не видит никогда, а
 * установка — главное, чего мы хотим от браузерной версии. Поэтому кнопка
 * живёт наверху постоянно, пока приложение не установлено.
 *
 * Показывается только там, где установка происходит в одно нажатие: Android и
 * десктопный Chromium дают `beforeinstallprompt`, и мы открываем системный
 * диалог. На iOS такого события нет — там остаётся инструкция в баннере,
 * рисовать кнопку, которая ничего не делает, нечестно.
 */
export function InstallButton() {
  const { t } = useSirr()
  // Приглашение приходит от браузера с задержкой — перерисовываемся по событию.
  const [, bump] = useState(0)
  useEffect(() => onInstallChange(() => bump((n) => n + 1)), [])

  if (authMode !== 'pwa' || isStandalone() || !canPromptInstall()) return null

  return (
    <button
      type="button"
      className="install-top"
      onClick={() => {
        haptic.impact('light')
        // Разрешение на уведомления просим сразу за установкой: это тот же
        // разговор («да, хочу приложение»), и жест ещё не истёк, а браузеры
        // без жеста запрос игнорируют.
        void promptInstall().then((installed) => {
          if (installed) void afterInstallAskPush()
        })
      }}
      aria-label={t('installText')}
    >
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
        <path d="M12 3v11M12 14l-4-4M12 14l4-4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" strokeLinecap="round" />
      </svg>
      {t('installBtn')}
    </button>
  )
}
